import React from 'react';
import LegalLayout from './LegalLayout';
import './legal.css';

const TermsAndConditions = () => {
  return (
    <LegalLayout title="Terms & Conditions">
      <div className="prose max-w-none">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">Terms and Conditions</h2>
        <p className="text-gray-500 mb-4">Last Updated: August 22, 2026</p>
        
        <section className="mb-8">
          <p className="text-gray-600 mb-4">
            These Terms and Conditions ("Terms", "Terms and Conditions") govern your relationship with smushlabs.ai website (the "Service") operated by SmushLabs ("us", "we", or "our").
          </p>
          <p className="text-gray-600 mb-4">
            Please read these Terms and Conditions carefully before using the Service.
          </p>
          <p className="text-gray-600 mb-4">
            Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.
          </p>
          <p className="text-gray-600 mb-4">
            By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Subscriptions</h3>
          <p className="text-gray-600 mb-4">
            Some parts of the Service are billed on a subscription basis ("Subscription(s)"). You will be billed in advance on a recurring and periodic basis ("Billing Cycle"). Billing cycles are set either on a monthly or annual basis, depending on the type of subscription plan you select when purchasing a Subscription.
          </p>
          <p className="text-gray-600 mb-4">
            At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions unless you cancel it or SmushLabs cancels it. You may cancel your Subscription renewal either through your online account management page or by contacting SmushLabs customer support team.
          </p>
          <p className="text-gray-600 mb-4">
            A valid payment method is required to process the payment for your Subscription. You shall provide SmushLabs with accurate and complete billing information including full name, address, state, zip code, telephone number, and a valid payment method information. By submitting such payment information, you automatically authorize SmushLabs to charge all Subscription fees incurred through your account to any such payment instruments.
          </p>
          <p className="text-gray-600 mb-4">
            Should automatic billing fail to occur for any reason, SmushLabs will issue an electronic invoice indicating that you must proceed manually, within a certain deadline date, with the full payment corresponding to the billing period as indicated on the invoice.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Demos, Setup and Onboarding</h3>
          <p className="text-gray-600 mb-4">
            SmushLabs does not currently offer a free plan or free trial. We may build a limited, no-cost preview using information from your public website so you can evaluate the experience before purchasing. A demo does not create a Subscription and does not require payment information.
          </p>
          <p className="text-gray-600 mb-4">
            If you purchase a plan, setup and onboarding are included and the approved chatbot can be associated with your Subscription. Full details are available in our Free Demo Policy.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Fee Changes</h3>
          <p className="text-gray-600 mb-4">
            SmushLabs, in its sole discretion and at any time, may modify the Subscription fees for the Subscriptions. Any Subscription fee change will become effective at the end of the then-current Billing Cycle.
          </p>
          <p className="text-gray-600 mb-4">
            SmushLabs will provide you with a reasonable prior notice of any change in Subscription fees to give you an opportunity to terminate your Subscription before such change becomes effective.
          </p>
          <p className="text-gray-600 mb-4">
            Your continued use of the Service after the Subscription fee change comes into effect constitutes your agreement to pay the modified Subscription fee amount.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Refunds</h3>
          <p className="text-gray-600 mb-4">
            Eligibility and the process for requesting a refund are described in our Cancellation & Refund Policy.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Content</h3>
          <p className="text-gray-600 mb-4">
            Our Service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material ("Content"). You are responsible for the Content that you post to the Service, including its legality, reliability, and appropriateness.
          </p>
          <p className="text-gray-600 mb-4">
            By posting Content to the Service, you grant us the right and license to use, modify, publicly perform, publicly display, reproduce, and distribute such Content on and through the Service. You retain any and all of your rights to any Content you submit, post or display on or through the Service and you are responsible for protecting those rights. You agree that this license includes the right for us to make your Content available to other users of the Service, who may also use your Content subject to these Terms.
          </p>
          <p className="text-gray-600 mb-4">
            You represent and warrant that: (i) the Content is yours (you own it) or you have the right to use it and grant us the rights and license as provided in these Terms, and (ii) the posting of your Content on or through the Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights of any person.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Accounts</h3>
          <p className="text-gray-600 mb-4">
            When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.
          </p>
          <p className="text-gray-600 mb-4">
            You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a third-party service.
          </p>
          <p className="text-gray-600 mb-4">
            You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.
          </p>
          <p className="text-gray-600 mb-4">
            You may not use as a username the name of another person or entity or that is not lawfully available for use, a name or trade mark that is subject to any rights of another person or entity other than you without appropriate authorization, or a name that is otherwise offensive, vulgar or obscene.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Copyright Policy</h3>
          <p className="text-gray-600 mb-4">
            We respect the intellectual property rights of others. It is our policy to respond to any claim that Content posted on the Service infringes the copyright or other intellectual property infringement ("Infringement") of any person.
          </p>
          <p className="text-gray-600 mb-4">
            If you are a copyright owner, or authorized on behalf of one, and you believe that the copyrighted work has been copied in a way that constitutes copyright infringement that is taking place through the Service, you must submit your notice in writing to the attention of "Copyright Infringement" of support@smushlabs.ai and include in your notice a detailed description of the alleged Infringement.
          </p>
          <p className="text-gray-600 mb-4">
            You may be held accountable for damages (including costs and attorneys' fees) for misrepresenting that any Content is infringing your copyright.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Intellectual Property</h3>
          <p className="text-gray-600 mb-4">
            The Service and its original content (excluding Content provided by users), features and functionality are and will remain the exclusive property of SmushLabs and its licensors. The Service is protected by copyright, trademark, and other laws of both India and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of SmushLabs.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Links To Other Web Sites</h3>
          <p className="text-gray-600 mb-4">
            Our Service may contain links to third-party web sites or services that are not owned or controlled by SmushLabs.
          </p>
          <p className="text-gray-600 mb-4">
            SmushLabs has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that SmushLabs shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.
          </p>
          <p className="text-gray-600 mb-4">
            We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that you visit.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Termination</h3>
          <p className="text-gray-600 mb-4">
            We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
          <p className="text-gray-600 mb-4">
            Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Limitation Of Liability</h3>
          <p className="text-gray-600 mb-4">
            In no event shall SmushLabs, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Disclaimer</h3>
          <p className="text-gray-600 mb-4">
            Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.
          </p>
          <p className="text-gray-600 mb-4">
            SmushLabs, its subsidiaries, affiliates, and its licensors do not warrant that a) the Service will function uninterrupted, secure or available at any particular time or location; b) any errors or defects will be corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the Service will meet your requirements.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Governing Law</h3>
          <p className="text-gray-600 mb-4">
            These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions.
          </p>
          <p className="text-gray-600 mb-4">
            Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Changes</h3>
          <p className="text-gray-600 mb-4">
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
          </p>
          <p className="text-gray-600 mb-4">
            By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.
          </p>
        </section>

        <section className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">Contact Us</h3>
          <p className="text-gray-600 mb-4">
            If you have any questions about these terms, please contact us:
          </p>
          <div className="bg-gray-50 p-4 rounded-md">
            <p className="text-gray-600">Email: support@smushlabs.ai</p>
            <p className="text-gray-600">Phone: +91 (789) 263-5932</p>
            <p className="text-gray-600">Address: Tulsi 117, Sahara Sunderban, Phase II, Jamshedpur, Jharkhand, 831012 India</p>
          </div>
        </section>
      </div>
    </LegalLayout>
  );
};

export default TermsAndConditions;
